<template>
  <div id="btn" class="flex items-center justify-center w-full shadow-md hover:shadow-sm uppercase cursor-pointer select-none">
    <div>{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
#btn {
  min-width: 44px;
  height: fit-content;
  padding: 0 1rem;
  border-radius: 2rem;
  font-size: 1rem;
  line-height: 2.75rem;
  background-color: #99397322;
  transition: background-color 500ms;
  white-space: nowrap;
  color: #993973;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  #btn {
    font-size: 0.875rem;
    line-height: 2.25rem;
  }
}

#btn.smallest {
  width: fit-content;
}

#btn.filled {
  background-color: #993973;
  color: white;
  pointer-events: none;
  box-shadow: none;
  transition: background-color 500ms;
}

#btn:hover {
  background-color: #99397355;
  color: #1f1f1f;
}

#btn.filled:hover {
  background-color: #993973dd;
  color: white;
}
</style>
